import { render, staticRenderFns } from "./ConfigurationSideNavItems.vue?vue&type=template&id=49d18a6c"
import script from "./ConfigurationSideNavItems.vue?vue&type=script&lang=ts"
export * from "./ConfigurationSideNavItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports